//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class DownloadClientBase {
  protected transformOptions(options: AxiosRequestConfig) {
    // https://github.com/RicoSuter/NSwag/pull/5283
    // Door een fix in NSwag wordt JSON.parse niet meer uitgevoerd wanneer Axios wordt gebruikt.
    // Er is dus geen nood meer om de transformResponse te overschrijven met een lege array.
    // options.transformResponse = []
    return Promise.resolve(options);
  }
}

export interface IDownloadClient {
    /**
     * @return Get Categories
     */
    categories_GetCategories( cancelToken?: CancelToken): Promise<CategoryHydraCollection>;
    /**
     * @return Get DatasetGroups
     */
    datasetGroup_GetDatasetGroups( cancelToken?: CancelToken): Promise<DatasetGroupHydraItem[]>;
    /**
     * @return Get DatasetGroup by Id
     */
    datasetGroup_GetDatasetGroupById(datasetGroupId: number,  cancelToken?: CancelToken): Promise<DatasetGroup>;
    /**
     * @return Get current notifications.
     */
    notifications_GetCurrentNotifications( cancelToken?: CancelToken): Promise<RequestForNotificationHydraItem[]>;
    /**
     * @return The Order is created
     */
    orders_CreateOrder(orderCreate: OrderConfigurationRequestV3,  cancelToken?: CancelToken): Promise<OrderCreatedHydraCollection>;
    /**
     * @param productNr (optional) 
     * @param version (optional) 
     * @param versnijding (optional) 
     * @param limit (optional) 
     * @param offset (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @return Get OrderHydraCollection.
     */
    orders_GetOrders(productNr?: number | null | undefined, version?: string | null | undefined, versnijding?: string | null | undefined, limit?: number | undefined, offset?: number | undefined, status?: EnumOrderStatus[] | null | undefined, sorting?: string | null | undefined,  cancelToken?: CancelToken): Promise<OrderHydraCollection>;
    /**
     * @param limit (optional) 
     * @param offset (optional) 
     * @param sorting (optional) 
     * @return Get OrderProductHydraCollection.
     */
    orders_GetOrderProducts(limit?: number | undefined, offset?: number | undefined, sorting?: string | null | undefined,  cancelToken?: CancelToken): Promise<OrderProductHydraCollection>;
    /**
     * @return Get Order By Id.
     */
    orders_GetOrderById(orderId: number,  cancelToken?: CancelToken): Promise<Order>;
    /**
     * @return Get OrderStatus.
     */
    orders_GetOrderStatusById(orderId: number,  cancelToken?: CancelToken): Promise<OrderStatus>;
    /**
     * @return Get Order download filestream.
     */
    orders_GetOrderDownloadFileById(orderId: number, fileId: string,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return Get most downloaded products
     */
    orders_GetMostDownloadedProducts( cancelToken?: CancelToken): Promise<ProductSummaryHydraItem[]>;
    /**
     * @param productTypes (optional) 
     * @param categories (optional) 
     * @param datasetGroupId (optional) 
     * @param openData (optional) 
     * @param dataAllowedForOrganisation (optional) 
     * @param searchTerm (optional) 
     * @param limit (optional) 
     * @param offset (optional) 
     * @param sort (optional) 
     * @return Get Catalog
     */
    products_GetProductCatalog(productTypes?: EnumProductType[] | null | undefined, categories?: number[] | null | undefined, datasetGroupId?: number | null | undefined, openData?: boolean | null | undefined, dataAllowedForOrganisation?: boolean | null | undefined, searchTerm?: string | null | undefined, limit?: number | undefined, offset?: number | undefined, sort?: string | null | undefined,  cancelToken?: CancelToken): Promise<ProductHydraCollection>;
    /**
     * @return Get Product by Number
     */
    products_GetProduct(number: number,  cancelToken?: CancelToken): Promise<Product>;
    /**
     * @return File downloaded
     */
    products_GetProductDocumentById(productId: number, documentId: string,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return File downloaded
     */
    products_GetProductExampleImageByIdHEAD(productId: number, exampleImageId: string,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return File downloaded
     */
    products_GetProductExampleImageByIdGET(productId: number, exampleImageId: string,  cancelToken?: CancelToken): Promise<FileResponse>;
    /**
     * @return Get newest and updated products
     */
    products_GetNewAndModifiedProducts( cancelToken?: CancelToken): Promise<ProductSummaryHydraItem[]>;
    /**
     * @param entityId (optional) 
     * @return Get preview layer
     */
    products_GetPreviewLayer(productId: number, entityId?: number | null | undefined,  cancelToken?: CancelToken): Promise<ProductPreviewLayerHydraItem>;
    /**
     * @param version (optional) 
     * @return Get Selection Entities by Id
     */
    selectionEntities_GetSelectionEntityById(id: number, version?: string | null | undefined,  cancelToken?: CancelToken): Promise<SelectionEntity>;
    /**
     * @return Get all Selection Entities
     */
    selectionEntities_GetSelectionEntities( cancelToken?: CancelToken): Promise<SelectionEntityHydraCollection>;
    /**
     * @return Get all Selection Entity versions
     */
    selectionEntities_GetSelectionEntityVersions( cancelToken?: CancelToken): Promise<SelectionEntityVersionHydraCollection>;
    /**
     * @return Get ApiInfo
     */
    apiInfo_ApiInfo( cancelToken?: CancelToken): Promise<ApiInfo>;
    /**
     * @return Logentry is created
     */
    logging_Log(logRequest: LogRequest,  cancelToken?: CancelToken): Promise<CreatedResponseBody>;
    /**
     * @return Returns userinfo of current user
     */
    auth_UserInfo( cancelToken?: CancelToken): Promise<UserResponse>;
    auth_Login(returnUrl?: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse | null>;
    auth_Logout( cancelToken?: CancelToken): Promise<FileResponse | null>;
    auth_SwitchIdentity( cancelToken?: CancelToken): Promise<FileResponse | null>;
    /**
     * @return Returns debug info of current user
     */
    auth_Debug( cancelToken?: CancelToken): Promise<any>;
    buildInfo_Index(api_version: string | null,  cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class DownloadClient extends DownloadClientBase implements IDownloadClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7120";

    }

    /**
     * @return Get Categories
     */
    categories_GetCategories( cancelToken?: CancelToken): Promise<CategoryHydraCollection> {
        let url_ = this.baseUrl + "/bff/v1/Categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategories_GetCategories(_response);
        });
    }

    protected processCategories_GetCategories(response: AxiosResponse): Promise<CategoryHydraCollection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<CategoryHydraCollection>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryHydraCollection>(null as any);
    }

    /**
     * @return Get DatasetGroups
     */
    datasetGroup_GetDatasetGroups( cancelToken?: CancelToken): Promise<DatasetGroupHydraItem[]> {
        let url_ = this.baseUrl + "/bff/v1/DatasetGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDatasetGroup_GetDatasetGroups(_response);
        });
    }

    protected processDatasetGroup_GetDatasetGroups(response: AxiosResponse): Promise<DatasetGroupHydraItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DatasetGroupHydraItem[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatasetGroupHydraItem[]>(null as any);
    }

    /**
     * @return Get DatasetGroup by Id
     */
    datasetGroup_GetDatasetGroupById(datasetGroupId: number, cancelToken?: CancelToken): Promise<DatasetGroup> {
        let url_ = this.baseUrl + "/bff/v1/DatasetGroup/{datasetGroupId}";
        if (datasetGroupId === undefined || datasetGroupId === null)
            throw new globalThis.Error("The parameter 'datasetGroupId' must be defined.");
        url_ = url_.replace("{datasetGroupId}", encodeURIComponent("" + datasetGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDatasetGroup_GetDatasetGroupById(_response);
        });
    }

    protected processDatasetGroup_GetDatasetGroupById(response: AxiosResponse): Promise<DatasetGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<DatasetGroup>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DatasetGroup>(null as any);
    }

    /**
     * @return Get current notifications.
     */
    notifications_GetCurrentNotifications( cancelToken?: CancelToken): Promise<RequestForNotificationHydraItem[]> {
        let url_ = this.baseUrl + "/bff/v1/Notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotifications_GetCurrentNotifications(_response);
        });
    }

    protected processNotifications_GetCurrentNotifications(response: AxiosResponse): Promise<RequestForNotificationHydraItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RequestForNotificationHydraItem[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestForNotificationHydraItem[]>(null as any);
    }

    /**
     * @return The Order is created
     */
    orders_CreateOrder(orderCreate: OrderConfigurationRequestV3, cancelToken?: CancelToken): Promise<OrderCreatedHydraCollection> {
        let url_ = this.baseUrl + "/bff/v1/Orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderCreate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrders_CreateOrder(_response);
        });
    }

    protected processOrders_CreateOrder(response: AxiosResponse): Promise<OrderCreatedHydraCollection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201;
            return Promise.resolve<OrderCreatedHydraCollection>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderCreatedHydraCollection>(null as any);
    }

    /**
     * @param productNr (optional) 
     * @param version (optional) 
     * @param versnijding (optional) 
     * @param limit (optional) 
     * @param offset (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @return Get OrderHydraCollection.
     */
    orders_GetOrders(productNr?: number | null | undefined, version?: string | null | undefined, versnijding?: string | null | undefined, limit?: number | undefined, offset?: number | undefined, status?: EnumOrderStatus[] | null | undefined, sorting?: string | null | undefined, cancelToken?: CancelToken): Promise<OrderHydraCollection> {
        let url_ = this.baseUrl + "/bff/v1/Orders?";
        if (productNr !== undefined && productNr !== null)
            url_ += "ProductNr=" + encodeURIComponent("" + productNr) + "&";
        if (version !== undefined && version !== null)
            url_ += "Version=" + encodeURIComponent("" + version) + "&";
        if (versnijding !== undefined && versnijding !== null)
            url_ += "Versnijding=" + encodeURIComponent("" + versnijding) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrders_GetOrders(_response);
        });
    }

    protected processOrders_GetOrders(response: AxiosResponse): Promise<OrderHydraCollection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<OrderHydraCollection>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderHydraCollection>(null as any);
    }

    /**
     * @param limit (optional) 
     * @param offset (optional) 
     * @param sorting (optional) 
     * @return Get OrderProductHydraCollection.
     */
    orders_GetOrderProducts(limit?: number | undefined, offset?: number | undefined, sorting?: string | null | undefined, cancelToken?: CancelToken): Promise<OrderProductHydraCollection> {
        let url_ = this.baseUrl + "/bff/v1/Orders/getorderproducts?";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrders_GetOrderProducts(_response);
        });
    }

    protected processOrders_GetOrderProducts(response: AxiosResponse): Promise<OrderProductHydraCollection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<OrderProductHydraCollection>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderProductHydraCollection>(null as any);
    }

    /**
     * @return Get Order By Id.
     */
    orders_GetOrderById(orderId: number, cancelToken?: CancelToken): Promise<Order> {
        let url_ = this.baseUrl + "/bff/v1/Orders/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrders_GetOrderById(_response);
        });
    }

    protected processOrders_GetOrderById(response: AxiosResponse): Promise<Order> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Order>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Order>(null as any);
    }

    /**
     * @return Get OrderStatus.
     */
    orders_GetOrderStatusById(orderId: number, cancelToken?: CancelToken): Promise<OrderStatus> {
        let url_ = this.baseUrl + "/bff/v1/Orders/{orderId}/status";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrders_GetOrderStatusById(_response);
        });
    }

    protected processOrders_GetOrderStatusById(response: AxiosResponse): Promise<OrderStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<OrderStatus>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderStatus>(null as any);
    }

    /**
     * @return Get Order download filestream.
     */
    orders_GetOrderDownloadFileById(orderId: number, fileId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/v1/Orders/{orderId}/download/{fileId}";
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrders_GetOrderDownloadFileById(_response);
        });
    }

    protected processOrders_GetOrderDownloadFileById(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Get most downloaded products
     */
    orders_GetMostDownloadedProducts( cancelToken?: CancelToken): Promise<ProductSummaryHydraItem[]> {
        let url_ = this.baseUrl + "/bff/v1/Orders/mostdownloaded";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrders_GetMostDownloadedProducts(_response);
        });
    }

    protected processOrders_GetMostDownloadedProducts(response: AxiosResponse): Promise<ProductSummaryHydraItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProductSummaryHydraItem[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductSummaryHydraItem[]>(null as any);
    }

    /**
     * @param productTypes (optional) 
     * @param categories (optional) 
     * @param datasetGroupId (optional) 
     * @param openData (optional) 
     * @param dataAllowedForOrganisation (optional) 
     * @param searchTerm (optional) 
     * @param limit (optional) 
     * @param offset (optional) 
     * @param sort (optional) 
     * @return Get Catalog
     */
    products_GetProductCatalog(productTypes?: EnumProductType[] | null | undefined, categories?: number[] | null | undefined, datasetGroupId?: number | null | undefined, openData?: boolean | null | undefined, dataAllowedForOrganisation?: boolean | null | undefined, searchTerm?: string | null | undefined, limit?: number | undefined, offset?: number | undefined, sort?: string | null | undefined, cancelToken?: CancelToken): Promise<ProductHydraCollection> {
        let url_ = this.baseUrl + "/bff/v1/Products/catalog?";
        if (productTypes !== undefined && productTypes !== null)
            productTypes && productTypes.forEach(item => { url_ += "ProductTypes=" + encodeURIComponent("" + item) + "&"; });
        if (categories !== undefined && categories !== null)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        if (datasetGroupId !== undefined && datasetGroupId !== null)
            url_ += "DatasetGroupId=" + encodeURIComponent("" + datasetGroupId) + "&";
        if (openData !== undefined && openData !== null)
            url_ += "OpenData=" + encodeURIComponent("" + openData) + "&";
        if (dataAllowedForOrganisation !== undefined && dataAllowedForOrganisation !== null)
            url_ += "DataAllowedForOrganisation=" + encodeURIComponent("" + dataAllowedForOrganisation) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetProductCatalog(_response);
        });
    }

    protected processProducts_GetProductCatalog(response: AxiosResponse): Promise<ProductHydraCollection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProductHydraCollection>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductHydraCollection>(null as any);
    }

    /**
     * @return Get Product by Number
     */
    products_GetProduct(number: number, cancelToken?: CancelToken): Promise<Product> {
        let url_ = this.baseUrl + "/bff/v1/Products/{number}";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetProduct(_response);
        });
    }

    protected processProducts_GetProduct(response: AxiosResponse): Promise<Product> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Product>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Product>(null as any);
    }

    /**
     * @return File downloaded
     */
    products_GetProductDocumentById(productId: number, documentId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/v1/Products/{productId}/documents/{documentId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetProductDocumentById(_response);
        });
    }

    protected processProducts_GetProductDocumentById(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return File downloaded
     */
    products_GetProductExampleImageByIdHEAD(productId: number, exampleImageId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/v1/Products/{productId}/exampleImages/{exampleImageId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (exampleImageId === undefined || exampleImageId === null)
            throw new globalThis.Error("The parameter 'exampleImageId' must be defined.");
        url_ = url_.replace("{exampleImageId}", encodeURIComponent("" + exampleImageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetProductExampleImageByIdHEAD(_response);
        });
    }

    protected processProducts_GetProductExampleImageByIdHEAD(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return File downloaded
     */
    products_GetProductExampleImageByIdGET(productId: number, exampleImageId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/v1/Products/{productId}/exampleImages/{exampleImageId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (exampleImageId === undefined || exampleImageId === null)
            throw new globalThis.Error("The parameter 'exampleImageId' must be defined.");
        url_ = url_.replace("{exampleImageId}", encodeURIComponent("" + exampleImageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetProductExampleImageByIdGET(_response);
        });
    }

    protected processProducts_GetProductExampleImageByIdGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Get newest and updated products
     */
    products_GetNewAndModifiedProducts( cancelToken?: CancelToken): Promise<ProductSummaryHydraItem[]> {
        let url_ = this.baseUrl + "/bff/v1/Products/newandmodified";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetNewAndModifiedProducts(_response);
        });
    }

    protected processProducts_GetNewAndModifiedProducts(response: AxiosResponse): Promise<ProductSummaryHydraItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProductSummaryHydraItem[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductSummaryHydraItem[]>(null as any);
    }

    /**
     * @param entityId (optional) 
     * @return Get preview layer
     */
    products_GetPreviewLayer(productId: number, entityId?: number | null | undefined, cancelToken?: CancelToken): Promise<ProductPreviewLayerHydraItem> {
        let url_ = this.baseUrl + "/bff/v1/Products/{productId}/previewLayer?";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProducts_GetPreviewLayer(_response);
        });
    }

    protected processProducts_GetPreviewLayer(response: AxiosResponse): Promise<ProductPreviewLayerHydraItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProductPreviewLayerHydraItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductPreviewLayerHydraItem>(null as any);
    }

    /**
     * @param version (optional) 
     * @return Get Selection Entities by Id
     */
    selectionEntities_GetSelectionEntityById(id: number, version?: string | null | undefined, cancelToken?: CancelToken): Promise<SelectionEntity> {
        let url_ = this.baseUrl + "/bff/v1/SelectionEntities/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelectionEntities_GetSelectionEntityById(_response);
        });
    }

    protected processSelectionEntities_GetSelectionEntityById(response: AxiosResponse): Promise<SelectionEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SelectionEntity>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectionEntity>(null as any);
    }

    /**
     * @return Get all Selection Entities
     */
    selectionEntities_GetSelectionEntities( cancelToken?: CancelToken): Promise<SelectionEntityHydraCollection> {
        let url_ = this.baseUrl + "/bff/v1/SelectionEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelectionEntities_GetSelectionEntities(_response);
        });
    }

    protected processSelectionEntities_GetSelectionEntities(response: AxiosResponse): Promise<SelectionEntityHydraCollection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SelectionEntityHydraCollection>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectionEntityHydraCollection>(null as any);
    }

    /**
     * @return Get all Selection Entity versions
     */
    selectionEntities_GetSelectionEntityVersions( cancelToken?: CancelToken): Promise<SelectionEntityVersionHydraCollection> {
        let url_ = this.baseUrl + "/bff/v1/SelectionEntities/versions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelectionEntities_GetSelectionEntityVersions(_response);
        });
    }

    protected processSelectionEntities_GetSelectionEntityVersions(response: AxiosResponse): Promise<SelectionEntityVersionHydraCollection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SelectionEntityVersionHydraCollection>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectionEntityVersionHydraCollection>(null as any);
    }

    /**
     * @return Get ApiInfo
     */
    apiInfo_ApiInfo( cancelToken?: CancelToken): Promise<ApiInfo> {
        let url_ = this.baseUrl + "/bff/v1/ApiInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiInfo_ApiInfo(_response);
        });
    }

    protected processApiInfo_ApiInfo(response: AxiosResponse): Promise<ApiInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApiInfo>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiInfo>(null as any);
    }

    /**
     * @return Logentry is created
     */
    logging_Log(logRequest: LogRequest, cancelToken?: CancelToken): Promise<CreatedResponseBody> {
        let url_ = this.baseUrl + "/bff/v1/Logging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogging_Log(_response);
        });
    }

    protected processLogging_Log(response: AxiosResponse): Promise<CreatedResponseBody> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201;
            return Promise.resolve<CreatedResponseBody>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedResponseBody>(null as any);
    }

    /**
     * @return Returns userinfo of current user
     */
    auth_UserInfo( cancelToken?: CancelToken): Promise<UserResponse> {
        let url_ = this.baseUrl + "/bff/v1/Auth/userInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_UserInfo(_response);
        });
    }

    protected processAuth_UserInfo(response: AxiosResponse): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponse>(null as any);
    }

    auth_Login(returnUrl?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/bff/v1/Auth/login?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_Login(_response);
        });
    }

    protected processAuth_Login(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    auth_Logout( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/bff/v1/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_Logout(_response);
        });
    }

    protected processAuth_Logout(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    auth_SwitchIdentity( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/bff/v1/Auth/switch-identity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_SwitchIdentity(_response);
        });
    }

    protected processAuth_SwitchIdentity(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * @return Returns debug info of current user
     */
    auth_Debug( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/bff/v1/Auth/debug";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuth_Debug(_response);
        });
    }

    protected processAuth_Debug(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    buildInfo_Index(api_version: string | null, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/BuildInfo?";
        if (api_version === undefined)
            throw new globalThis.Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildInfo_Index(_response);
        });
    }

    protected processBuildInfo_Index(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface CategoryHydraCollection {
    id: string;
    context: string[];
    type: string;
    member: CategoryHydraItem[];
    totalItems: number;
}

export interface CategoryHydraItem {
    id: string;
    type: string;
    context: string[];
    categoryId: number;
    name: string;
    totalProducts: number;
}

export interface BadRequestResponseBody {
    type?: string | undefined;
    title?: string | undefined;
    status: number;
    detail?: string | undefined;
    errors?: ErrorDto[] | undefined;
}

export interface ErrorDto {
    type?: string | undefined;
    title?: string | undefined;
    detail?: string | undefined;
}

export interface UnauthorizedResponseBody {
    type?: string | undefined;
    title?: string | undefined;
    status: number;
    detail?: string | undefined;
}

export interface ForbiddenResponseBody {
    type?: string | undefined;
    title?: string | undefined;
    status: number;
    detail?: string | undefined;
}

export interface NotFoundResponseBody {
    type?: string | undefined;
    title?: string | undefined;
    status: number;
    detail?: string | undefined;
}

export interface InternalServerErrorResponseBody {
    type?: string | undefined;
    title?: string | undefined;
    status: number;
    detail?: string | undefined;
}

export interface DatasetGroupHydraItem {
    id: string;
    type: string;
    context: string[];
    datasetGroupId: number;
    name: string;
    description: string;
}

export interface DatasetGroup {
    id: string;
    type: string;
    context: string[];
    datasetGroupId: number;
    name: string;
    description: string;
    datasets: ProductOverview[];
}

export interface ProductOverview {
    id: string;
    type: string;
    context: string[];
    productId: number;
    name: string;
    description: string;
    isOpenData?: boolean | undefined;
    isOrderAllowed?: boolean | undefined;
    temporaryUnavailable: boolean;
    orderAllowedRoles?: string[] | undefined;
}

export interface RequestForNotificationHydraItem {
    notificationId: string;
    datumGewijzigd?: Date | undefined;
    title?: string | undefined;
    content?: string | undefined;
    type: RequestForNotificationHydraItemType;
    closeable: boolean;
    start: Date;
    end?: Date | undefined;
    location: RequestForNotificationHydraItemLocation;
    producten?: RequestForNotificationProductsHydraItem[] | undefined;
}

export enum RequestForNotificationHydraItemType {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export enum RequestForNotificationHydraItemLocation {
    HomePage = "HomePage",
    WholeSite = "WholeSite",
    ProductPage = "ProductPage",
}

export interface RequestForNotificationProductsHydraItem {
    productId: number;
    productNaam?: string | undefined;
}

export interface OrderCreatedHydraCollection {
    id: string;
    type: string;
    context: string[];
    view: HydraPartialCollectionView;
    member: OrderCreatedHydraItem[];
    totalItems: number;
}

export interface HydraPartialCollectionView {
    id?: string | undefined;
    type?: string | undefined;
    first?: string | undefined;
    previous?: string | undefined;
    next?: string | undefined;
    last?: string | undefined;
}

export interface OrderCreatedHydraItem {
    orderId: number;
}

export interface OrderConfigurationRequestV3 {
    productId: number;
    format?: string | undefined;
    discreteVersionIds?: string[] | undefined;
    fileIds?: string[] | undefined;
    geographicalCrop?: GeographicalCropRequest | undefined;
    temporalCrop?: TemporalCrop | undefined;
    email?: string | undefined;
    mailOnProcessed?: boolean | undefined;
    crs?: string | undefined;
}

export interface GeographicalCropRequest {
    clip: boolean;
    selectionEntityCode?: string | undefined;
    selectionEntityCodeValue?: string[] | undefined;
    polygon?: Polygon | undefined;
}

export interface Polygon {
    coordinates: number[][];
}

export interface TemporalCrop {
    from?: Date | undefined;
    to?: Date | undefined;
}

export interface OrderHydraCollection {
    id: string;
    type: string;
    context: string[];
    view: HydraPartialCollectionView2;
    member: OrderHydraItem[];
    totalItems: number;
}

export interface HydraPartialCollectionView2 {
    id?: string | undefined;
    type?: string | undefined;
    first?: string | undefined;
    previous?: string | undefined;
    next?: string | undefined;
    last?: string | undefined;
}

export interface OrderHydraItem {
    id: string;
    orderId: number;
    orderTimestamp: Date;
    productName?: string | undefined;
    productId?: number | undefined;
    productType: EnumProductType;
    format: string;
    version?: string | undefined;
    orderConfiguration?: OrderConfigurationResponse | undefined;
    expireDate?: Date | undefined;
    download?: OrderDownloadFile | undefined;
    status: EnumOrderStatus;
    statusTimestamp: Date;
    crs?: string | undefined;
}

export enum EnumProductType {
    Dataset = "Dataset",
    Entity = "Entity",
}

export interface OrderConfigurationResponse {
    productId: number;
    format?: string | undefined;
    crs?: string | undefined;
    discreteVersionIds?: string[] | undefined;
    fileIds?: string[] | undefined;
    geographicalCrop?: GeographicalCropResponse | undefined;
    temporalCrop?: TemporalCrop2 | undefined;
    email?: string | undefined;
    mailOnProcessed?: boolean | undefined;
}

export interface GeographicalCropResponse {
    clip: boolean;
    selectionEntityCode?: string | undefined;
    selectionEntityCodeValue?: string[] | undefined;
    selectionEntityCodeDescription?: string[] | undefined;
    polygon?: Polygon2 | undefined;
}

export interface Polygon2 {
    coordinates: number[][];
}

export interface TemporalCrop2 {
    from?: Date | undefined;
    to?: Date | undefined;
}

export interface OrderDownloadFile {
    fileId: string;
    name: string;
    size: number;
}

export enum EnumOrderStatus {
    Received = "Received",
    Processing = "Processing",
    Completed = "Completed",
    Error = "Error",
}

export interface OrderProductHydraCollection {
    id: string;
    type: string;
    context: string[];
    view: HydraPartialCollectionView2;
    member: OrderProductHydraItem[];
    totalItems: number;
}

export interface OrderProductHydraItem {
    productName?: string | undefined;
    productId?: number | undefined;
    productType: EnumProductType;
}

export interface Order {
    id: string;
    context: string;
    orderId: number;
    orderTimestamp: Date;
    status: string;
    statusTimestamp?: Date | undefined;
    volume?: string | undefined;
    orderconfiguration: OrderConfigurationResponse;
    downloads?: OrderDownload[] | undefined;
    expireDate?: Date | undefined;
}

export interface OrderDownload {
    id: string;
    context: string;
    fileId: string;
    name: string;
    volume?: string | undefined;
}

export interface OrderStatus {
    status: EnumOrderStatus;
}

export interface ProductSummaryHydraItem {
    productId: number;
    name: string;
}

export interface ProductHydraCollection {
    id: string;
    type: string;
    context: string[];
    view: HydraPartialCollectionView2;
    member: ProductHydraItem[];
    totalItems: number;
}

export interface ProductHydraItem {
    id: string;
    productId: number;
    name: string;
    partOfDataset?: ProductOverview | undefined;
    description: string;
    productType: EnumProductType;
    keywords?: string | undefined;
    isOpenData?: boolean | undefined;
    datePublished?: Date | undefined;
    isOrderAllowed?: boolean | undefined;
    temporaryUnavailable: boolean;
    orderAllowedRoles?: string[] | undefined;
    categories?: Category[] | undefined;
}

export interface Category {
    id: string;
    type: string;
    context?: string[] | undefined;
    categoryId: number;
    name: string;
}

export interface Product {
    id: string;
    type: string;
    context: string[];
    productId: number;
    name: string;
    partOfDataset?: ProductOverview | undefined;
    description: string;
    productType: EnumProductType;
    keywords: string[];
    isOpenData?: boolean | undefined;
    allowClip?: boolean | undefined;
    datePublished?: Date | undefined;
    isOrderAllowed?: boolean | undefined;
    temporaryUnavailable: boolean;
    orderAllowedRoles?: string[] | undefined;
    formats?: string[] | undefined;
    categories: Category[];
    documents: Document[];
    selectionEntities: ProductSelectionEntity[];
    dataset?: Dataset | undefined;
    entity?: Entity | undefined;
    files?: PredefinedDownloadFile[] | undefined;
    allowDifferenceFiles?: boolean | undefined;
    allowHistoricVersions?: boolean | undefined;
    historicStartDate?: Date | undefined;
    historicEndDate?: Date | undefined;
    differenceFileMinStartDate?: Date | undefined;
    differenceFileMaxStartDate?: Date | undefined;
    differenceFileMinEndDate?: Date | undefined;
    differenceFileMaxEndDate?: Date | undefined;
    discreteVersions: DiscreteVersion[];
    allowPreview?: boolean | undefined;
    referenceSystems?: ReferenceSystem[] | undefined;
}

export interface Document {
    id: string;
    documentId: string;
    name: string;
    type: string;
    size: number;
}

export interface ProductSelectionEntity {
    id: string;
    selectionEntityId: number;
    name: string;
}

export interface Dataset {
    id: string;
    type: string;
    context: string[];
    productId: number;
    fileIdentifier: string;
    version?: string | undefined;
    status?: string | undefined;
    versionDate: Date;
    applicationScale: string;
    spatialRepresentation: string;
    metadataUrl: string;
    entities?: Entity[] | undefined;
    exampleimages?: ExampleImage[] | undefined;
    license?: string | undefined;
    usecontraints?: UsageContraint[] | undefined;
    datasetGroupId?: number | undefined;
}

export interface Entity {
    id: string;
    type: string;
    context: string[];
    name: string;
    description: string;
    productId: number;
    featureTypeId: string;
    isAllowedToOrderSeparately: boolean;
    isAllowedToOrder: boolean;
}

export interface ExampleImage {
    id: string;
}

export interface UsageContraint {
    level: string;
    contraints: string[];
}

export interface PredefinedDownloadFile {
    fileId: string;
    name: string;
    format?: string | undefined;
    size: number;
    selectionEntityId?: EnumSelectionEntity | undefined;
    version?: string | undefined;
    crs?: ReferenceSystem | undefined;
}

export enum EnumSelectionEntity {
    Onbekend = "Onbekend",
    GeenVersnijding = "GeenVersnijding",
    Gemeente = "Gemeente",
    Provincie = "Provincie",
    KaartBlad = "KaartBlad",
}

export interface ReferenceSystem {
    name?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export interface DiscreteVersion {
    discreteVersionId: string;
    fileIdentifier: string;
    description: string;
    versionDate: Date;
}

export interface ProductPreviewLayerHydraItem {
    name: string;
    serviceUrl?: string | undefined;
    crs?: string | undefined;
    style?: string | undefined;
    serviceType?: ProductPreviewLayerServiceType | undefined;
}

export enum ProductPreviewLayerServiceType {
    WMS = "WMS",
    WMTS = "WMTS",
}

export interface SelectionEntity {
    id: string;
    type: string;
    context: string[];
    selectionEntityId: number;
    name: string;
    code: string;
    selectionEntityValues: SelectionEntityValue[];
}

export interface SelectionEntityValue {
    codeValue: string;
    geometry: string;
    name: string;
}

export interface SelectionEntityHydraCollection {
    id: string;
    type: string;
    context: string[];
    member: SelectionEntityHydraItem[];
    totalItems: number;
}

export interface SelectionEntityHydraItem {
    id: string;
    type: string;
    context: string[];
    selectionEntityId: number;
    name: string;
    code: string;
}

export interface SelectionEntityVersionHydraCollection {
    id: string;
    type: string;
    context: string[];
    member: SelectionEntityVersionHydraItem[];
    totalItems: number;
}

export interface SelectionEntityVersionHydraItem {
    type: string;
    context: string[];
    name: string;
    description: string;
    code: string;
}

export interface ApiInfo {
    environment: string;
    buildTag: string;
}

export interface CreatedResponseBody {
    status: number;
    message?: string | undefined;
    location?: string | undefined;
}

export interface LogRequest {
    loggingLevel: LogLevel;
    message?: string | undefined;
}

export enum LogLevel {
    Trace = "Trace",
    Debug = "Debug",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
    None = "None",
}

export interface UserResponse {
    voId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organisationName?: string | undefined;
    organisationCode?: string | undefined;
    email?: string | undefined;
    roles?: string[] | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}